import React, { useEffect, useState } from "react";
import { AsyncSelect } from "@caelor/ui";
import { useTheme } from "styled-components";
import { groupService } from "@Shared/Service/GroupService";

function mapGroup(group) {
  return {
    id: group.id,
    label: group.name,
    value: group.id,
  };
}

const GroupPicker = ({
  initialGroupId,
  onUpdate,
  placeholder = "Filter by group",
}) => {
  const [selectedGroup, setSelectedGroup] = useState(undefined);
  const theme = useTheme();

  useEffect(() => {
    if (!initialGroupId) return;
    (async () => {
      const response = await groupService.getGroupById(initialGroupId);
      const { data } = response;
      setSelectedGroup(mapGroup(data || {}));
    })();
  }, [initialGroupId]);

  const loadOptions = async (query) => {
    try {
      const groups = await groupService.getGroupsByName(query);
      const { data } = groups;

      const formattedGroups = data?.results?.map(mapGroup);
      return formattedGroups;
    } catch (error) {
      return [];
    }
  };

  return (
    <AsyncSelect
      isSearchable
      placeholder={placeholder}
      isClearable
      onChange={(e) => {
        if (e) {
          setSelectedGroup(e);
          onUpdate(e);
        } else {
          setSelectedGroup("");
          onUpdate("");
        }
      }}
      value={selectedGroup}
      loadOptions={loadOptions}
      theme={theme}
    />
  );
};
export default GroupPicker;
